import React from "react";

const experienceContent = [
  {
    year: "January 2023 - Current",
    position: "Software Engineer",
    compnayName: "IP Dynamics GmbH",
    details: "Building business-critical React applications with complex UI workflows, bug fixing, accessibility improvements and maintainable frontend architecture."
  },
  {
    year: "April 2022 - December 2022",
    position: "Web Developer",
    compnayName: "CommonMedia GmbH",
    details: "Worked on web applications and ad operations tools with a focus on technical infrastructure, publisher integrations and campaign-related workflows."
  },
  {
    year: "August 2021 - December 2021",
    position: "Software Developer",
    compnayName: "agorum Software GmbH",
    details: "Worked on customer projects, feature development, configuration, support and software improvements."
  },
  {
    year: "June 2020 - July 2021",
    position: "Android Developer",
    compnayName: "ShopiApps OÜ",
    details: "Built and maintained Android app features with focus on usability, functionality and reliable implementation."
  }
];

const Experience = () => {
  return (
    <ul>
      {experienceContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <img src="img/about/work.png" alt="icon" />
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.position}
            <span className="place open-sans-font">{val.compnayName}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Experience;
